export default () => ({
  show: false,
  loading: false,
  checkout: false,
  wishlistHandles: [],
  wishlist: [],
  count: 0,
  wishCount: 0,
  showProducts: false,
  currency: null,

  open() {
    this.show = true;
    Grebify.noScroll(true);
    this.setProducts();
  },

  close() {
    this.wishlist = [];
    Grebify.noScroll(false);
    this.show = false;
  },

  setProducts() {
    CF.customerReady(
      function () {
        const wishlistHandles = CF.customer.get("favorites_list") || [];
        this.wishlistHandles = wishlistHandles;
      }.bind(this)
    );

    this.currency = ` ${Shopify.currency.active}`;
    this.wishlistHandles.map(this.fetchProduct.bind(this));
  },

  fetchProduct(handle) {
    const url = `${Shopify.routes.root}products/${handle}.js`;
    fetch(url)
      .then((res) => res.text())
      .then((res) => {
        this.wishCount += 1;
        this.wishlist.push(JSON.parse(res));

        if (this.wishCount == this.wishlistHandles.length) {
          this.showProducts = true;
        }
      })
      .catch((err) =>
        console.error(
          `[Shopify Wishlist] Failed to load content for handle: ${handle}`,
          err
        )
      );
  },

  removeProduct(event, handle) {
    let productWrapper = event.target.closest(".cart-item");

    //check if element has siblings
    let siblings = this.getSiblings(productWrapper);

    if (siblings.some((e) => e.classList.contains("cart-item"))) {
      productWrapper.remove();
    } else {
      // remove list wrapper (including title);
      let wrapper = productWrapper.closest(".list-wrapper");
      wrapper.remove();
    }

    // remove item from customer favorites
    this.updateWishlist(handle);
  },

  updateWishlist(handle) {
    let wishlistHandles = this.wishlistHandles;
    wishlistHandles.splice(wishlistHandles.indexOf(handle), 1);

    CF.customerReady(
      function () {
        if (!CF.customer.id) {
          CF.customer.set("favorites_list", wishlistHandles);
          CF.customer.saveAsGuest();
          return;
        }
        CF.customer.update({
          favorites_list: wishlistHandles,
        });
      }.bind(this)
    );
  },

  getSiblings(e) {
    let siblings = [];

    if (!e.parentNode) {
      return siblings;
    }

    let sibling = e.parentNode.firstChild;

    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  },
});
